import React, { useCallback, useEffect, useState } from 'react'
import { IMaskInput } from 'react-imask'

const PhoneMask = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props
  return (
    <IMaskInput
      placeholder='Введите номер телефона'
      {...other}
      mask='+7 (#00) 000-0000'
      definitions={{
        '#': /[9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange(value)}
      overwrite
    />
  )
})

const normalize = (value_) => {
  return value_
    .replace(' ', '')
    .replace('+7', '')
    .replace('(', '')
    .replace(') ', '')
    .replace('-', '')
}

export default function PhoneInputJS({
  defaultValue,
  isRequired,
  invalidMessage,
  onChange,
  onEntered,
  style,
}) {
  const [value, setValue] = useState('')
  const [isFirstInput, setIsFirstInput] = useState(true)
  const [isValid, setIsValid] = useState(false)

  const handleChange = useCallback(
    (value_) => {
      const normalizedValue = normalize(value_)
      setValue(normalizedValue)

      if (normalizedValue.length === 10) {
        if (normalizedValue !== defaultValue) {
          onEntered && onEntered(normalizedValue)
        }

        onChange(normalizedValue)
        setIsValid(true)
        setIsFirstInput(false)
      } else {
        if (value_.length === 0) {
          onEntered && onEntered('')
        }
        onChange('')
        setIsValid(false)
      }
    },
    [defaultValue, onChange, onEntered]
  )

  const handleBlur = () => {
    setIsFirstInput(false)
  }

  const getClassName = useCallback(() => {
    if (isFirstInput) return 'form-control'
    if (invalidMessage) return 'form-control is-invalid'
    if (isValid) return 'form-control is-valid'
    if (isRequired) return 'form-control is-invalid'
    else return 'form-control'
  }, [isFirstInput, isRequired, isValid, invalidMessage])

  const getDisplay = useCallback(() => {
    if (isFirstInput) return 'none'
    if (invalidMessage) return 'block'
    if (isValid) return 'none'
    if (isRequired && !isValid) return 'block'
    else return 'none'
  }, [isFirstInput, isRequired, isValid, invalidMessage])

  useEffect(() => {
    if (defaultValue /*&& defaultValue !== value*/) {
      setValue(defaultValue)
      const normalizedValue = normalize(defaultValue)
      if (normalizedValue.length === 10) {
        setIsValid(true)
      }
    }
  }, [defaultValue])

  return (
    <>
      <PhoneMask
        value={value}
        type='text'
        className={getClassName()}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <div
        className='invalid-feedback'
        style={{
          display: getDisplay(),
        }}
      >
        {invalidMessage ? invalidMessage : 'Введите номер телефона'}
      </div>
    </>
  )
}
